import { render } from "./ShowSamplingValue.vue?vue&type=template&id=20967026"
import script from "./ShowSamplingValue.vue?vue&type=script&lang=js"
export * from "./ShowSamplingValue.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__